<template>
  <ValidationObserver @submit="addSupportQueryType">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>
          {{ modalHeading }}
        </span>
      </template>
      <template v-slot>
        <div>
          <InputFieldWrapper>
            <InputBox
              v-model="supportQueryType.title"
              type="text"
              name="QUERY_TYPE"
              title="QUERY_TYPE"
              label="QUERY_TYPE"
              placeholder="QUERY_TYPE"
              class="flex-1 w-full"
              rules="required"
            />

            <InputBox
              v-model="supportQueryType.description"
              type="text"
              name="Description"
              title="Description"
              label="Description"
              placeholder="Description"
              class="flex-1 w-full"
            />
          </InputFieldWrapper>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>
              {{ primaryButtonText }}
            </span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import { mapActions } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import { Form as ValidationObserver } from 'vee-validate'
import UIButton from '@src/components/UiElements/UIButton.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiModalContainer,
    InputBox,
    ValidationObserver,
    Loader,
    UIButton,
    InputFieldWrapper,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['toggle'],
  data() {
    return {
      supportQueryType: {
        title: '',
        description: '',
      },
      isLoading: false,
    }
  },
  computed: {
    primaryButtonText() {
      return this.edit ? 'Update' : 'Save'
    },
    modalHeading() {
      return this.edit ? 'Edit Support Query Type' : 'Add Support Query Type'
    },
  },
  created() {
    if (this.edit) this.setFormDate()
  },
  methods: {
    async addSupportQueryType() {
      try {
        this.isLoading = true
        const payload = { query: this.supportQueryType }
        if (this.edit) payload.id = this.edit.id

        const [res, err] = await this.createAndUpdateSupportQueryType(payload)
        if (!err) this.$emit('toggle', true)
      } finally {
        this.isLoading = false
      }
    },
    setFormDate() {
      this.supportQueryType.title = this.edit?.title || ''
      this.supportQueryType.description = this.edit?.description || ''
    },
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('toggle')
          break
      }
    },
    ...mapActions('supportQuery', ['createAndUpdateSupportQueryType']),
  },
}
</script>
